import { localizer } from "@stormglass/game-localization";

import { useInstallPrompt } from "../hooks/useInstallPrompt";

export function InstallScreen(): React.JSX.Element {
  const install = useInstallPrompt();
  return (
    <div className="install-page page-panel">
      <div className="install-visual" aria-hidden="true">
        <div className="install-phone">
          <span className="install-phone__speaker" />
          <div className="install-phone__screen">
            <i className="install-core">ϟ</i>
            <strong>STORMGLASS</strong>
            <small>WEATHER CHAMBER DEFENSE</small>
          </div>
        </div>
        <span className="install-orbit" />
      </div>
      <div className="install-copy">
        <p className="eyebrow">INSTALLABLE // OFFLINE READY</p>
        <h1>{localizer.t("install.title")}</h1>
        <p className="page-lede">{localizer.t("install.detail")}</p>
        <div className="install-benefits">
          <span>
            <i>✓</i>
            <strong>Full-screen portrait play</strong>
            <small>No browser chrome around the battlefield.</small>
          </span>
          <span>
            <i>✓</i>
            <strong>Reliable offline launch</strong>
            <small>Play local runs after the first successful load.</small>
          </span>
          <span>
            <i>✓</i>
            <strong>Safe local progression</strong>
            <small>Double-buffered checkpoints remain on this device.</small>
          </span>
        </div>
        {install.installed ? (
          <div className="install-ready">✓ {localizer.t("install.ready")}</div>
        ) : install.available ? (
          <button
            className="button button--primary button--large"
            type="button"
            onClick={() => void install.prompt()}
          >
            Install STORMGLASS <b>↓</b>
          </button>
        ) : (
          <div className="manual-install">
            <strong>
              {install.isIos ? "iPhone & iPad" : "Browser installation"}
            </strong>
            <p>
              {install.isIos
                ? localizer.t("install.ios")
                : localizer.t("install.android")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
